import * as React from 'react';
import { LayerManagerComponent } from './layer-manager-component';
const featureAppDefinition = {
    dependencies: {
        featureServices: {
            'layer-manager': '^2.7.2',
        },
    },
    create: ({ featureServices }) => {
        const layerManager = featureServices['layer-manager'];
        return {
            render: () => React.createElement(LayerManagerComponent, { layerManager: layerManager }),
        };
    },
};
export default featureAppDefinition;
//# sourceMappingURL=index.js.map